import React from "react";
import img from "../images/startup-3267505_640.jpg";
import img2 from "../images/success-4165306_640.jpg";
import img3 from "../images/stock-6596787_640.jpg";
import img4 from "../images/trading-6531134_640.jpg";

const Services = () => {
  return (
    <div id="services" className="bg-gray-100 py-12">
      <section data-aos="zoom-in-down">
        <div className="my-4 py-4">
          <h2 className="my-2 text-center text-3xl text-blue-900 uppercase font-bold">
            services
          </h2>

          <div className="flex justify-center">
            <div className="w-24 border-b-4 border-blue-900"></div>
          </div>
          <h2 className="mt-4 mx-12 text-center text-xl lg:text-2xl font-semibold text-blue-900">
            We are deeply committed to the growth and success of our clients.
          </h2>
        </div>

        <div className="px-12" data-aos="fade-down" data-aos-delay="600">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            <div className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 hover:bg-gray-500 hover:text-white rounded-lg shadow-2xl p-3 group">
              <div className="m-2 text-justify text-sm">
                <img
                  alt="card img"
                  className="rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out"
                  src={img}
                />
                <h2 className="font-semibold my-4 text-2xl text-center">
                  Trading Strategy Development
                </h2>
                <p className="text-md font-medium">
                  Our experts design bespoke trading strategies tailored to your
                  goals. Leveraging advanced technical analysis tools like
                  Ichimoku Clouds, RSI, and Fibonacci retracements, we help you
                  pinpoint market trends, optimize entry/exit points, and
                  minimize risks. Whether you're a novice or an experienced
                  trader, we offer both manual and algorithmic solutions to give
                  you the competitive edge needed in the fast-paced world of
                  blockchain trading.
                </p>
              </div>
            </div>

            <div className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 hover:bg-gray-500 hover:text-white rounded-lg shadow-2xl p-3 group">
              <div className="m-2 text-justify text-sm">
                <img
                  alt="card img"
                  className="rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out"
                  src={img2}
                />
                <h2 className="font-semibold my-4 text-2xl text-center">
                  Technical Reports & Analysis
                </h2>
                <p className="text-md font-medium">
                  Stay ahead of the curve with our in-depth technical analysis
                  reports. Delivered daily or weekly, these reports decode
                  market trends, price movements, and potential reversals using
                  data-driven insights. Our team employs industry-leading tools
                  and proprietary models to provide actionable guidance, helping
                  you make informed decisions with confidence.
                </p>
              </div>
            </div>

            <div className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 hover:bg-gray-500 hover:text-white rounded-lg shadow-2xl p-3 group">
              <div className="m-2 text-justify text-sm">
                <img
                  alt="card img"
                  className="rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out"
                  src={img3}
                />
                <h2 className="font-semibold my-4 text-2xl text-center ">
                  Private Investment Opportunities
                </h2>
                <p className="text-md font-medium">
                  Gain access to high-growth blockchain ventures and tokenized
                  assets through our private investment services. From
                  early-stage startups to innovative DeFi projects, we identify,
                  vet, and connect you with opportunities poised for significant
                  returns.
                </p>
              </div>
            </div>

            <div className="bg-white transition-all ease-in-out duration-400  overflow-hidden text-gray-700 hover:bg-gray-500 hover:text-white rounded-lg shadow-2xl p-3 group">
              <div className="m-2 text-justify text-sm">
                <img
                  alt="card img"
                  className="rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out"
                  src={img4}
                />
                <h2 className="font-semibold my-4 text-2xl text-center ">
                  Identifying Emerging Markets
                </h2>
                <p className="text-md font-medium">
                  Navigate the rapidly evolving crypto landscape with our
                  expertise in identifying emerging markets. We analyze market
                  trends, on-chain activity, volume movement, and project
                  fundamentals to uncover opportunities before they bubble up to
                  the social networks. From groundbreaking technology
                  developments to underserved niches, we equip you with the
                  knowledge and tools to seize high potential investments.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="m-auto max-w-6xl p-2 md:p-12 h-5/6">
          <div
            className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left"
            data-aos="zoom-out"
          >
            <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
              <h3
                className="text-3xl  text-blue-900 
                            font-bold"
              >
                <span className="font-black">Technical Analysis</span>
              </h3>
              <div>
                <p className="my-3 text-xl text-gray-600 font-semibold">
                  With over 10 years experience in cryptocurrency technical
                  analysis, charting design, and a deep understanding of
                  emerging trends, we provide investing strategies and
                  customized reporting to help enhance your portfolio diversity,
                  reduce risk, and maximize opportunities in a global market.
                </p>
              </div>
            </div>
            <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
              <h3 className="text-3xl  text-blue-900 font-bold">
                <span className="font-black">Collaboration</span>
              </h3>
              <div>
                <p className="my-3 text-xl text-gray-600 font-semibold">
                  We can collaborate with your tech team
                  to scale existing software applications or design customized
                  solutions that suit your everyday investing and trading
                  workflows. We provide bespoke solutions for realtime trading strategy alerting
                  and messaging solutions enhanced for your trading API
                  integrations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
